import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

/* @71170 - Dados cadastrais de planjemaneto de safra */

export default class TipoCulturaValidation extends DefaultValidation{
    constructor(msgs) {
        super(msgs);
    }

    validate(model, permissao, refs) {
        let validated = true;

        if (Util.isNull(model.idusuario)) {
            refs.usuarioInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idempresa)) {
            refs.empresaInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idcliente)) {
            refs.clienteInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idagrosafra)) {
            refs.safraInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idtipocultura)) {
            refs.culturaInput.focusedOut = true;
            validated = false;
        }
        // campos configuráveis
        if (
            permissao.ativaniveltecnologico==2&&
            Util.isNull(model.idagroniveltecnologico)
        ) {
            refs.niveltecnologicoInput.focusedOut = true;
            validated = false;
        }
        if (permissao.ativacultivar==2&&Util.isNull(model.idcultivar)) {
            refs.cultivarInput.focusedOut = true;
            validated = false;
        }
        if (
            (permissao.ativaformulaadubacao==2&&
            Util.isNull(model.formulaadubacao))||
            (permissao.ativaformulaadubacao==2&&
            model.formulaadubacao.length != 8)
        ) {
            refs.formulaadubacaoNInput.focusedOut = true;
            refs.formulaadubacaoPInput.focusedOut = true;
            refs.formulaadubacaoKInput.focusedOut = true;
            validated = false;
        }
        if (permissao.ativaqtdeadubacao==2&&Util.isNull(model.qtdeadubacao)) {
            refs.qtdeadubacaoInput.focusedOut = true;
            validated = false;
        }
        if (permissao.ativaplantasmetroquadrado==2&&Util.isNull(model.plantasmetroquadrado)) {
            refs.plantasmetroquadradoInput.focusedOut = true;
            validated = false;
        }
        if (permissao.ativacolunaespaco==2&&Util.isNull(model.colunaespaco)) {
            refs.colunaespacoInput.focusedOut = true;
            validated = false;
        }
        if (permissao.ativalinhaespaco==2&&Util.isNull(model.linhaespaco)) {
            refs.linhaespacoInput.focusedOut = true;
            validated = false;
        }
        if (permissao.ativaprevisaoproducao==2&&Util.isNull(model.previsaoproducao)) {
            refs.previsaoprodutoInput.focusedOut = true;
            validated = false;
        }
        if (permissao.ativadatasemeadura==2&&Util.isNull(model.datasemeadura)) {
            refs.dataInput.focusedOut = true;
            validated = false;
        }
        if (permissao.ativaareatotalplantio==2&&Util.isNull(model.areatotalplantio)) {
            refs.areatotalplantioInput.focusedOut = true;
            validated = false;
        }
        if (permissao.ativadatacolheita==2&&Util.isNull(model.datacolheita)) {
            refs.dataColheitaInput.focusedOut = true;
            validated = false;
        }
        if (permissao.ativaprodutividadeobtida==2&&Util.isNull(model.produtividadeobtida)) {
            refs.produtividadeObtidaInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }
}
